<template>
  <a-modal
    class="modal-content"
    title="处理提醒"
    :width="650"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model ref="ruleForm" :labelCol="labelCol" :wrapperCol="wrapperCol" :model="form">
        <a-form-model-item label="问题原因">
          <j-dict-select-tag
            v-model="form.tagId"
            placeholder="请选择问题原因"
            dictCode="emotional_type"
          />
        </a-form-model-item>
        <a-form-model-item label="干预措施">
          <j-dict-select-tag
            v-model="form.interventionId"
            placeholder="请选择干预措施"
            dictCode="intervention"
          />
        </a-form-model-item>
        <a-form-model-item label="其他措施">
          <!--          <WangEditor-->
          <!--            v-model="form.comment"-->
          <!--            :editorStyle="{ minHeight: '200px' }"-->
          <!--            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"-->
          <!--          />-->
          <a-textarea v-model="form.comment" :auto-size="{ minRows: 6, maxRows: 10 }" />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction } from '@api/manage'
// import WangEditor from '@/components/WangEditor'

export default {
  name: 'DisposeRemind',
  mixins: [JeecgListMixin],
  components: {
    // WangEditor,
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 19 },
      form: {},
    }
  },
  methods: {
    showModal(record) {
      console.log('record记录', record)
      this.$set(this.form, 'id', record.id)
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const params = {
          ...this.form,
          comment: '已跟进处理，' + this.form.comment || '',
          warnStatus: 7,
          visible: 1,
        }
        console.log('参数信息：', params)
        const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', params)
        if (res.success) {
          this.$message.success(res.message)
          console.log('表单数据：', params)
          this.hideModal()
          this.$emit('refreshData')
          return
        }
        this.$message.error(res.message)
      })
    },
  },
}
</script>
<style scoped lang="less">
//.modal-content {
//  /deep/ .ant-form-item {
//    margin-bottom: 12px;
//  }
//}
</style>
